import { createSlice } from '@reduxjs/toolkit';
import { ToastTypeEnum, ToastPositionEnum } from '../../consts/ToastConst';
const initialState = {
    current: {
        type: ToastTypeEnum.none,
        title: '',
        message: '',
        isOnModal: false,
        position: ToastPositionEnum.top
    },
    next: {
        type: ToastTypeEnum.none,
        title: '',
        message: '',
        isOnModal: false,
        position: ToastPositionEnum.top
    },
};
const flushToasterSlice = createSlice({
    name: 'flushToasterSlice',
    initialState,
    reducers: {
        setCurrentFlushToasterAction(state, action) {
            state.current = action.payload;
            return state;
        },
        setNextFlushToasterAction(state, action) {
            state.next = action.payload;
            return state;
        },
        setNextToCurrentFlushToasterAction(state) {
            state.current = state.next;
            state.next = {
                type: ToastTypeEnum.none,
                title: '',
                message: '',
                isOnModal: false
            };
            return state;
        },
    },
});
//Actions
export const { setCurrentFlushToasterAction, setNextFlushToasterAction, setNextToCurrentFlushToasterAction,
//    hideFlushToasterAction
 } = flushToasterSlice.actions;
export default flushToasterSlice;
